import ServerStatusPage from "./ServerStatusPage";

export {ServerStatusPage}
export default ServerStatusPage